import styles from './ui.module.css';

/** The BlackBlack "B" mark (vector of the chosen Tech-style logo). */
export function LogoMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={(size * 236) / 232} viewBox="0 0 232 236" role="img" aria-label="BlackBlack">
      <path
        fill="currentColor"
        d="M14 3V108L45 80V49H155C166 49 173 57 173 67C173 75 170 81 165 86L112 136H157C170 136 181 147 181 162C181 176 170 188 156 188H75V173L10 233H166C201 233 228 206 228 169C228 142 213 120 192 110C208 101 217 84 217 65C217 30 191 3 160 3Z"
      />
      <path fill="var(--accent)" d="M80 81H135L3 205V153Z" />
    </svg>
  );
}

/** Wordmark: "Black" in white + "Black" in the accent colour. */
export function Wordmark({ size = 22, withMark = false }: { size?: number; withMark?: boolean }) {
  return (
    <span className={styles.wordmark} style={{ fontSize: size }} aria-label="BlackBlack">
      {withMark && <LogoMark size={size * 1.15} />}
      <span aria-hidden="true">
        Black<span className={styles.wordmarkAccent}>Black</span>
      </span>
    </span>
  );
}
